export function formatUTCToTimestamp(dateTimeString: string) {
  // Parse the input string in the format "YYYY-MM-DD HH:mm:ss"
  const [datePart, timePart] = dateTimeString.split(' ');
  let [year, month, day] = datePart.split('-').map(Number);
  const [hours, minutes, seconds] = timePart.split(':').map(Number);

  // Create a Date object using the parsed UTC values
  const utcDate = new Date(
    Date.UTC(year, month - 1, day, hours, minutes, seconds)
  );

  // Get the current local date and time for comparison
  const today = new Date(); // Current local date and time

  // Create a Date object for yesterday's local date
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1); // Adjust to get yesterday's date

  // Format the local time in AM/PM format based on the browser's local time zone
  const formattedTime = utcDate.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true, // 12-hour format with AM/PM
  });

  // Check if it's today in the browser's local time zone
  if (
    utcDate.getDate() === today.getDate() &&
    utcDate.getMonth() === today.getMonth() &&
    utcDate.getFullYear() === today.getFullYear()
  ) {
    return `Today at ${formattedTime}`;
  }

  // Check if it's yesterday in the browser's local time zone
  if (
    utcDate.getDate() === yesterday.getDate() &&
    utcDate.getMonth() === yesterday.getMonth() &&
    utcDate.getFullYear() === yesterday.getFullYear()
  ) {
    return `Yesterday at ${formattedTime}`;
  }

  // Format the date in the local timezone
  const formattedLocalDate = utcDate.toLocaleDateString([], {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return `${formattedLocalDate} at ${formattedTime}`;
}
